// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Sxtg","delete":"styles_delete__Xxb_P","update":"styles_update__3UIfQ","add":"styles_add__2S5El"};